import React, { useRef, useEffect, useState } from 'react';
import API from '../../Common/API';
import { motion } from 'framer-motion';
import { MdCurrencyRupee, MdOutlineStarBorder } from 'react-icons/md';
import cash from '../../Assets/Images/cod.png';
import returns from '../../Assets/Images/returns.png';
import topBrand from '../../Assets/Images/topbrand.png';
import TabButtonGroup from '../../Components/Tabs/TabButtonGroup';
import TabButton from '../../Components/Tabs/TabButton';
import Tab from '../../Components/Tabs/Tab';
import TabGroup from '../../Components/Tabs/TabGroup';
import { BsBookmarkHeart, BsBookmarkHeartFill } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { setBuyNowProducts } from '../../Store/Auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../Store/Theme/actions';
import StarRatingDisplay from '../../Components/StarRatingDisplay';
import { BsPersonCircle } from 'react-icons/bs';
import premiumBrand from '../../Assets/Images/premium.png';
import { FaFacebook, FaWhatsapp, FaEnvelope, FaInstagram } from 'react-icons/fa';
import {
    FacebookShareButton,
    InstapaperShareButton,
    WhatsappShareButton,
    EmailShareButton,
} from 'react-share';
import { FaShareNodes } from 'react-icons/fa6';

const quantities = [
    { text: 1, value: 1 },
    { text: 2, value: 2 },
    { text: 3, value: 3 },
    { text: 4, value: 4 },
    { text: 5, value: 5 },
    { text: 6, value: 6 },
    { text: 7, value: 7 },
    { text: 8, value: 8 },
    { text: 9, value: 9 },
    { text: 10, value: 10 },
    { text: 11, value: 11 },
    { text: 12, value: 12 },
    { text: 13, value: 13 },
    { text: 14, value: 14 },
    { text: 15, value: 15 },
    { text: 16, value: 16 },
    { text: 17, value: 17 },
    { text: 18, value: 18 },
    { text: 19, value: 19 },
    { text: 20, value: 20 },
];

const ViewProduct = ({ match }) => {
    const [productDetails, setProductDetails] = useState();
    const [loading, setLoading] = useState(true);
    const [previewImage, setPreviewImage] = useState();
    const [tab, setTab] = useState(0);
    const history = useHistory();
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.auth.userDetails);
    const [count, setCount] = useState(0);
    const fromWishlist = localStorage.getItem('fromWishList');
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const lang = useSelector((state) => state.theme.language);
    const [showPopover, setShowPopover] = useState(false);
    const popoverRef = useRef(null);
    const [shareUrl, setShareUrl] = useState('');

    useEffect(() => {
        API.get(`/products/getProductById/${match.params.productId}`).then((prodRes) => {
            if (prodRes.status === 200) {
                let product = prodRes.data.data;
                if (product.productData) {
                    product.productData.userOrderQuantity = 1;
                    product.fromWishList = fromWishlist === 'true' ? true : false;
                    product.fromCart = false;
                    setProductDetails(product);
                    setShareUrl(
                        `${process.env.REACT_APP_URL}/brand/${product?.productData?.addedBy}/viewProducts`
                    );
                    setPreviewImage(prodRes?.data?.data?.imageData[0]?.imageUrl);
                    setLoading(false);
                }
            }
        });
    }, [match.params.productId, count]);
    const title = productDetails?.productData?.productName || 'Check this out!';

    // Close popover on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setShowPopover(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const checkOut = () => {
        dispatch(setBuyNowProducts([productDetails]));
        localStorage.setItem('buyNowProducts', JSON.stringify(productDetails));
        history.push('/product/checkOut');
    };

    const addToCart = () => {
        let values = {
            productId: productDetails.productData._id,
            userOrderQuantity: productDetails.userOrderQuantity,
            addedBy: userDetails.subject._id,
        };
        API.post('/products/addToCart', values).then((cartRes) => {
            if (cartRes.status === 200) {
                dispatch(
                    setAlert({
                        type: 'success',
                        title: 'Success',
                        subtitle: 'Product added to the cart',
                        active: true,
                    })
                );
                setCount(count + 1);
            }
        });
    };

    const addToWishList = () => {
        try {
            let values = {
                productId: productDetails.productData._id,
                addedBy: userDetails.subject._id,
            };
            API.post('/products/wishList', values).then((wishRes) => {
                if (wishRes.status === 200) {
                    setProductDetails({ ...productDetails, wishListData: wishRes.data.data });
                }
            });
        } catch (err) {
            throw err;
        }
    };

    const getProductDisplayName = (productDetails) => {
        if (lang === 'en') {
            const { productName, brandName, modelName } = productDetails.productData || {};
            return [productName, brandName, modelName].filter(Boolean).join(' / ');
        } else if (lang === 'ta') {
            const { tProductName, tBrandName, tModelName } = productDetails.productData || {};
            return [tProductName, tBrandName, tModelName].filter(Boolean).join(' / ');
        } else {
            const { productName, brandName, modelName } = productDetails.productData || {};
            return [productName, brandName, modelName].filter(Boolean).join(' / ');
        }
    };

    return (
        <>
            {loading
                ? 'Loading please wait...'
                : productDetails && (
                      <motion.div className="w-full h-full relative flex flex-col justify-center items-center px-2 md:px-20">
                          <motion.div className="grid grid-cols-1 gap-10 sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 lg:grid-cols-2">
                              <motion.div className="flex flex-row">
                                  <motion.div className="flex flex-col h-[500px] overflow-scroll">
                                      {productDetails &&
                                          productDetails?.imageData?.map((image) => {
                                              return (
                                                  <motion.div
                                                      className="cursor-pointer my-1"
                                                      onClick={() =>
                                                          setPreviewImage(image?.imageUrl)
                                                      }
                                                  >
                                                      <img
                                                          alt="images"
                                                          src={image?.imageUrl}
                                                          height={100}
                                                          width={100}
                                                      />
                                                  </motion.div>
                                              );
                                          })}
                                  </motion.div>
                                  <motion.div className="flex flex-col justify-center h-[550px] w-full py-2 relative items-center px-2">
                                      <motion.div
                                          className="absolute top-5 right-5 h-[550px] text-xl cursor-pointer"
                                          onClick={() =>
                                              isLoggedIn
                                                  ? addToWishList()
                                                  : history.push('/auth/login')
                                          }
                                      >
                                          {productDetails.wishListData !== null &&
                                          productDetails?.wishListData?.activeStat === 'A' ? (
                                              <BsBookmarkHeartFill />
                                          ) : (
                                              <BsBookmarkHeart />
                                          )}
                                      </motion.div>
                                      <img
                                          alt="images"
                                          src={previewImage}
                                          className="h-[550px] object-contain"
                                      />
                                  </motion.div>
                              </motion.div>
                              <motion.div className="flex flex-col px-2 py-2">
                                  <motion.div className="text-3xl font-bold">
                                      {getProductDisplayName(productDetails)}
                                  </motion.div>
                                  <motion.div className="flex flex-row px-2 items-center py-2">
                                      <StarRatingDisplay reviews={productDetails.reviews} />
                                  </motion.div>
                                  <motion.div className="h-[1.5px] px-2 rounded-full w-full md:w-60 bg-black"></motion.div>
                                  <motion.div className="text-black text-3xl my-2 px-2 font-bold flex flex-row items-center">
                                      <MdCurrencyRupee />
                                      &nbsp;
                                      {productDetails.productData.offerPercentage === 0
                                          ? productDetails.productData.price
                                          : productDetails.productData.price *
                                            (productDetails.productData.offerPercentage / 100)}
                                      &nbsp;
                                      <p className="text-black text-xs font-bold">
                                          (
                                          {productDetails.stockData.stockMode === 'inStock'
                                              ? 'In Stock'
                                              : 'Out of Stock'}
                                          )
                                      </p>
                                  </motion.div>
                                  <div className="relative inline-block">
                                      <a className="flex flex-row gap-2 items-center">
                                          Visit{' '}
                                          <span
                                              className="underline text-primeColor font-bold cursor-pointer"
                                              onClick={() =>
                                                  history.push(
                                                      `/brand/${productDetails.productData.addedBy}/viewProducts`
                                                  )
                                              }
                                          >
                                              {productDetails.productData.brandName}
                                          </span>
                                          <span
                                              className="cursor-pointer text-black font-bold relative"
                                              onClick={() => setShowPopover(!showPopover)}
                                          >
                                              <FaShareNodes />
                                          </span>
                                      </a>

                                      {showPopover && (
                                          <div
                                              ref={popoverRef}
                                              className="absolute top-full mt-2 left-20 bg-white border shadow-md rounded-lg p-3 flex gap-3 z-50"
                                          >
                                              <FacebookShareButton url={shareUrl} quote={title}>
                                                  <FaFacebook className="text-blue-600" size={20} />
                                              </FacebookShareButton>
                                              <WhatsappShareButton url={shareUrl} title={title}>
                                                  <FaWhatsapp
                                                      className="text-green-600"
                                                      size={20}
                                                  />
                                              </WhatsappShareButton>
                                              <EmailShareButton
                                                  url={shareUrl}
                                                  subject={title}
                                                  body="Check this out: "
                                              >
                                                  <FaEnvelope className="text-red-600" size={20} />
                                              </EmailShareButton>
                                              <button
                                                  onClick={() => {
                                                      navigator.clipboard.writeText(shareUrl);
                                                      dispatch(
                                                          setAlert({
                                                              type: 'success',
                                                              title: 'Link Copied!',
                                                              subtitle:
                                                                  'Product share link has been copied to clipboard.',
                                                              active: true,
                                                          })
                                                      );
                                                      setShowPopover(false);
                                                  }}
                                                  className="text-gray-700 hover:text-black"
                                                  title="Copy Link"
                                              >
                                                  <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      height="20"
                                                      width="20"
                                                      fill="currentColor"
                                                      viewBox="0 0 24 24"
                                                  >
                                                      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                                                  </svg>
                                              </button>
                                          </div>
                                      )}
                                  </div>
                                  <motion.div className="w-full my-2 px-2 py-2 flex flex-row">
                                      <motion.div className="text-black mx-2">
                                          Quantity :
                                      </motion.div>
                                      <motion.div>
                                          <select
                                              className="w-20"
                                              onChange={(ev) => {
                                                  setProductDetails({
                                                      ...productDetails,
                                                      productData: {
                                                          ...productDetails.productData,
                                                          userOrderQuantity: ev.target.value,
                                                      },
                                                  });
                                              }}
                                              value={productDetails.productData.userOrderQuantity}
                                          >
                                              {quantities.map((quan) => (
                                                  <option key={quan.value} value={quan.value}>
                                                      {quan.text}
                                                  </option>
                                              ))}
                                          </select>
                                      </motion.div>
                                  </motion.div>
                                  {productDetails.stockData.stockMode === 'inStock' ? (
                                      <motion.div className="w-full flex flex-row md:flex-col">
                                          <motion.div className="w-full px-2 py-2">
                                              {productDetails.cartData === null ? (
                                                  <motion.div
                                                      className="w-fit px-5 py-2 cursor-pointer bg-primeColor/20 text-black font-bold"
                                                      onClick={() =>
                                                          isLoggedIn
                                                              ? addToCart()
                                                              : history.push('/auth/login')
                                                      }
                                                  >
                                                      Add to cart
                                                  </motion.div>
                                              ) : (
                                                  <motion.div
                                                      className="w-fit px-5 py-2 cursor-pointer bg-primeColor/20 text-black font-bold"
                                                      onClick={() => history.push('/cart')}
                                                  >
                                                      Added to cart
                                                  </motion.div>
                                              )}
                                          </motion.div>
                                          <motion.div className="w-full px-2 py-2">
                                              <motion.div
                                                  className="w-fit px-5 py-2 cursor-pointer bg-black text-white font-bold"
                                                  onClick={() =>
                                                      isLoggedIn
                                                          ? checkOut()
                                                          : history.push('/auth/login')
                                                  }
                                              >
                                                  Buy Now
                                              </motion.div>
                                          </motion.div>
                                      </motion.div>
                                  ) : (
                                      <motion.div className="my-10">
                                          <motion.div className="w-full px-2 py-2">
                                              <motion.div className="w-fit px-5 py-2 cursor-pointer text-[red] font-bold">
                                                  Currently Unavailable
                                              </motion.div>
                                          </motion.div>
                                      </motion.div>
                                  )}
                                  <motion.div className="my-2 px-2 py-2">
                                      <motion.div className="text-black flex-wrap flex flex-row text-md font-bold">
                                          Category:{' '}
                                          <motion.div
                                              className="text-black underline mx-2 cursor-pointer"
                                              onClick={() =>
                                                  history.push(
                                                      `/shopping/category/${productDetails.productData.category._id}`
                                                  )
                                              }
                                          >
                                              {productDetails.productData.category.category}
                                          </motion.div>{' '}
                                          /{' '}
                                          <motion.div
                                              className="text-black underline mx-2 cursor-pointer"
                                              onClick={() =>
                                                  history.push(
                                                      `/shopping/category/${productDetails.productData.subCategory._id}`
                                                  )
                                              }
                                          >
                                              {productDetails.productData.subCategory.subCategory}
                                          </motion.div>
                                      </motion.div>
                                  </motion.div>
                                  <motion.div className="w-full h-[2px] bg-black"></motion.div>
                                  <motion.div className="grid grid-cols-1 sm:grid-cols-1 gap-10 xl:grid-cols-6 lg:grid-cols-6 my-5">
                                      <motion.div className="flex flex-col">
                                          <motion.div className="px-2 py-1">
                                              <img alt="images" src={cash} height={30} width={30} />
                                          </motion.div>
                                          <motion.div className="text-black text-sm font-bold">
                                              Online pay
                                          </motion.div>
                                      </motion.div>
                                      <motion.div className="flex flex-col">
                                          <motion.div className="px-2 py-1">
                                              <img
                                                  alt="images"
                                                  src={returns}
                                                  height={30}
                                                  width={30}
                                              />
                                          </motion.div>
                                          <motion.div className="text-black text-sm font-bold">
                                              Return policy
                                          </motion.div>
                                      </motion.div>
                                      <motion.div className="flex flex-col">
                                          <motion.div className="px-2 py-1">
                                              <img
                                                  alt="images"
                                                  src={topBrand}
                                                  height={30}
                                                  width={30}
                                              />
                                          </motion.div>
                                          <motion.div className="text-black text-sm font-bold">
                                              Top Brand
                                          </motion.div>
                                      </motion.div>
                                      {productDetails.productData.isOrganic && (
                                          <motion.div className="flex items-center flex-col">
                                              <motion.div className="px-2 w-8 h-8 flex flex-col items-center justify-center border border-1 border-[#0c6c2b] py-1">
                                                  <motion.div className="w-3 h-3 rounded-full bg-[#0c6c2b] flex items-center justify-center"></motion.div>
                                              </motion.div>
                                              <motion.div className="text-black mt-3 text-sm font-bold">
                                                  Organic
                                              </motion.div>
                                          </motion.div>
                                      )}
                                      {productDetails.productData.isHomemade && (
                                          <motion.div className="flex items-center flex-col">
                                              <motion.div className="px-2 w-8 h-8 flex flex-col items-center justify-center border border-1 border-[#654321] py-1">
                                                  <motion.div className="w-3 h-3 rounded-full bg-[#654321] flex items-center justify-center"></motion.div>
                                              </motion.div>
                                              <motion.div className="text-black mt-3 text-sm font-bold">
                                                  Homemade
                                              </motion.div>
                                          </motion.div>
                                      )}
                                      {productDetails.productData.isPremium && (
                                          <motion.div className="flex items-center flex-col">
                                              <motion.div className="px-2 py-1">
                                                  <img
                                                      alt="images"
                                                      src={premiumBrand}
                                                      height={30}
                                                      width={30}
                                                  />
                                              </motion.div>
                                              <motion.div className="text-black mt-3 text-sm font-bold">
                                                  Premium (First Quality)
                                              </motion.div>
                                          </motion.div>
                                      )}
                                  </motion.div>
                                  <motion.div className="w-full h-[2px] bg-black"></motion.div>
                              </motion.div>
                          </motion.div>
                          <motion.div className="w-full h-[1px] hidden md:block rounded-full bg-black my-5"></motion.div>
                          <motion.div className="w-full">
                              <motion.div className="items-center justify-center flex flex-row my-5">
                                  <TabButtonGroup>
                                      <TabButton
                                          index={0}
                                          value={tab}
                                          setValue={setTab}
                                          id={'Description'}
                                      >
                                          Description
                                      </TabButton>
                                      <TabButton
                                          index={1}
                                          value={tab}
                                          setValue={setTab}
                                          id={'Reviews`'}
                                      >
                                          Reviews
                                      </TabButton>
                                  </TabButtonGroup>
                              </motion.div>
                              <TabGroup value={tab}>
                                  <Tab index={0} value={tab}>
                                      <motion.div
                                          className="text-bold font-md w-full"
                                          dangerouslySetInnerHTML={{
                                              __html: productDetails.productData.productDescription,
                                          }}
                                      />
                                  </Tab>
                                  <Tab index={1} value={tab}>
                                      {productDetails.reviews.length > 0 &&
                                          productDetails.reviews.map((review) => {
                                              return (
                                                  <motion.div className="grid grid-cols-1 gap-5 my-5 relative">
                                                      <motion.div className="flex flex-row">
                                                          <BsPersonCircle className="text-5xl font-bold text-[gray]" />
                                                          &nbsp;
                                                          <motion.div className="flex flex-row mx-2 items-center">
                                                              {review.reviewedBy.firstName}
                                                          </motion.div>
                                                      </motion.div>
                                                      <StarRatingDisplay
                                                          reviews={[review]}
                                                          ratingsLabel={false}
                                                      />
                                                      <motion.div className="flex flex-row">
                                                          {review.images.length > 0 &&
                                                              review.images.map((image) => {
                                                                  return (
                                                                      <img
                                                                          src={image.imageUrl}
                                                                          height={100}
                                                                          width={100}
                                                                          className="mx-2"
                                                                      />
                                                                  );
                                                              })}
                                                      </motion.div>
                                                      <motion.div className="flex flex-col">
                                                          <motion.div className="text-xl font-bold">
                                                              {review.headline}
                                                          </motion.div>
                                                          <motion.div className="text-md">
                                                              {review.review}
                                                          </motion.div>
                                                      </motion.div>
                                                  </motion.div>
                                              );
                                          })}
                                  </Tab>
                              </TabGroup>
                          </motion.div>
                      </motion.div>
                  )}
        </>
    );
};

export default ViewProduct;
